export const VENDORPAYMENT_FILE = 'VENDORPAYMENT_FILE';
// 更新
export const VENDORPAYMENT_UPDATE = 'VENDORPAYMENT_UPDATE';
